<template>
    <div class="video-chapter">
        <slot></slot>
        <h1 class="video-chapter-title">{{ chapter.name }}</h1>
        <div class="video-player-wrap">
            <div v-if="videoSource.type === 'embed'"
                 ref="player"
                 :data-plyr-provider="videoSource.provider"
                 :data-plyr-embed-id="videoSource.id"
            ></div>
            <video v-else ref="player" playsinline controls></video>
        </div>
        <p v-if="chapter.description" class="video-chapter-description">{{ chapter.description }}</p>
        <div class="article-complete-card">
            <a class="btn primary-btn" @click="$router.push({ name: 'categoryDashboard', params: { category: $route.params.category } })">
                {{ $t("ARTICLE_COMPLETE_BACK_BUTTON") }}
            </a>
        </div>
    </div>
</template>
<!---------------------------------------------------------------------------->
<script>
    import { mapGetters } from "vuex";
    import Plyr from 'plyr/dist/plyr.min';

    const MIME_TYPES = { mp4: 'video/mp4', webm: 'video/webm', ogg: 'video/ogg', ogv: 'video/ogg' };

    export default {
        name: "VideoChapter",

        computed: {
            ...mapGetters(["chapter"]),

            videoSource() {
                const url = this.chapter.content || '';
                let match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/)([^&?/]+)/);
                if (match) return { type: 'embed', provider: 'youtube', id: match[1] };
                match = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                if (match) return { type: 'embed', provider: 'vimeo', id: match[1] };
                return { type: 'file', url };
            },
        },

        data() {
            return { videoPlayer: null };
        },

        mounted() {
            this.videoPlayer = new Plyr(this.$refs.player);

            if (this.videoSource.type === 'file') {
                const ext = this.videoSource.url.split('?')[0].split('.').pop().toLowerCase();
                this.videoPlayer.source = {
                    type: 'video',
                    sources: [{ src: this.videoSource.url, type: MIME_TYPES[ext] || 'video/mp4' }],
                };
            }
        },

        beforeDestroy() {
            if (this.videoPlayer) {
                this.videoPlayer.destroy();
            }
        },
    };
</script>
<!---------------------------------------------------------------------------->
<style lang="scss" type="text/scss">
    .video-chapter {
        width: 100%;

        .video-chapter-title {
            font-weight: 700;
            font-size: 40px;
            line-height: 50px;
            padding: 10px 0;
        }

        .video-player-wrap {
            margin: 30px 0;
            border-radius: 20px;
            overflow: hidden;
        }

        .video-chapter-description {
            font-size: 22px;
            line-height: 140%;
            margin-bottom: 30px;
        }
    }
</style>
